import { IssuesView } from "./_components";

export default function IssuesPage() {
  return <IssuesView />;
}
